import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getDocumentTypes,getOpenInvoices,createSettlementNo } from "../Api/Reconciliation";
import BRBD from "./BRBD";
import { getBRBDDocuments } from "../Api/BRBD";
import {
  fetchCustomersByOrgId,
  fetchCurrency,
} from "../Api/InvoiceApi";
import { useAuth } from "../Context/AuthContext";
import { Modal } from "react-bootstrap";



const PostDocument = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { monthId, houseBankId } = useParams();
  const { statement } = location.state || {};
  const [brbdDocs, setBrbdDocs] = useState([]);
const [showBRBD, setShowBRBD] = useState(false);
const { user } = useAuth();

const [documentTypes, setDocumentTypes] = useState([]);
const [currencies, setCurrencies] = useState([]);
const [customers, setCustomers] = useState([]);

const [selectedType, setSelectedType] = useState("");
const [selectedCurrency, setSelectedCurrency] = useState("");
const [selectedCustomer, setSelectedCustomer] = useState("");
const [showPostModal, setShowPostModal] = useState(false);
const [showSettleModal, setShowSettleModal] = useState(false);
const [openInvoices, setOpenInvoices] = useState([]);
const [checkingInvoices, setCheckingInvoices] = useState(false);

useEffect(() => {
  const loadInitialData = async () => {
    try {
      const [docTypes, currencyData] = await Promise.all([
        getDocumentTypes(),
        fetchCurrency(),
      ]);

      setDocumentTypes(docTypes || []);
      setCurrencies(currencyData || []);
    } catch (err) {
      console.error("Error loading dropdown data", err);
    }
  };

  loadInitialData();
}, []);
useEffect(() => {
  const loadBRBDDocs = async () => {
    try {
      const res = await getBRBDDocuments();
      setBrbdDocs(res || []);
    } catch (err) {
      console.error("BRBD docs fetch failed", err);
    }
  };

  loadBRBDDocs();
}, []);
useEffect(() => {
  const exists = brbdDocs.some(
    (doc) => doc.zCode === selectedType
  );

  setShowBRBD(exists);
}, [selectedType, brbdDocs]);
const settlementNoPayload = {
  statementId: statement.statementId,
  userId: user.userId,
  organisationId: user.organisationId,
};
useEffect(() => {
  if (selectedType === "B1") { // Customer Payment
    fetchCustomersByOrgId(user.organisationId)
      .then((res) => setCustomers(res || []))
      .catch((err) => console.error("Customer fetch failed", err));
  } else {
    setCustomers([]);
    setSelectedCustomer("");
  }
}, [selectedType, user?.organisationId]);

  if (!statement) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">
          No statement data found. Please go back.
        </div>
        <Button
          variant="secondary"
          onClick={() =>
            navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`)
          }
        >
          Back
        </Button>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h4>Post Document</h4>

      <div className="card mt-3">
        <div className="card-header">
          <h5>Statement Details</h5>
        </div>

        <div className="card-body">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>Statement ID</th>
                <td>{statement.statementId}</td>
              </tr>
              <tr>
                <th>Transaction ID</th>
                <td>{statement.transactionId}</td>
              </tr>
              <tr>
                <th>Narration</th>
                <td>{statement.narration}</td>
              </tr>
              <tr>
                <th>Bank Name</th>
                <td>{statement.bankName}</td>
              </tr>
              <tr>
                <th>Account Number</th>
                <td>{statement.accountNumber}</td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{statement.transactionAmount}</td>
              </tr>
              <tr>
                <th>Credit / Debit</th>
                <td>{statement.creditDebit}</td>
              </tr>
              <tr>
                <th>Transaction Date</th>
                <td>
                  {new Date(statement.valueDate).toLocaleDateString()}
                </td>
              </tr>
            </tbody>
          </table>
            <Form className="mt-4">
  {/* Document Type */}
  <Form.Group className="mb-3">
    <Form.Label>Select Type</Form.Label>
    <Form.Select
      value={selectedType}
      onChange={(e) => setSelectedType(e.target.value)}
    >
      <option value="">-- Select Document Type --</option>
      {documentTypes.map((doc) => (
        <option key={doc.code} value={doc.code}>
          {doc.code} - {doc.description}
        </option>
      ))}
    </Form.Select>
  </Form.Group>

  {/* Currency (Always Visible) */}
  <Form.Group className="mb-3">
    <Form.Label>Currency</Form.Label>
    <Form.Select
      value={selectedCurrency}
      onChange={(e) => setSelectedCurrency(e.target.value)}
    >
      <option value="">-- Select Currency --</option>
      {currencies.map((cur) => (
        <option key={cur.currencyCode} value={cur.currencyCode}>
          {cur.currencyCode} - {cur.currencyName}
        </option>
      ))}
    </Form.Select>
  </Form.Group>

  {/* Customer Dropdown (Only for Customer Payment) */}
  {selectedType === "B1" && (
    <Form.Group className="mb-3">
      <Form.Label>Customer</Form.Label>
      <Form.Select
        value={selectedCustomer}
        onChange={(e) => setSelectedCustomer(e.target.value)}
      >
        <option value="">-- Select Customer --</option>
        {customers.map((cust) => (
          <option key={cust.customerCode + cust.taxId} value={cust.customerCode}>
            {cust.customerCode} - {cust.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  )}
</Form>
{showBRBD && (
  <BRBD
    selectedType={selectedType}
    statementId={statement.statementId}
    statement={statement}
    selectedCurrency={selectedCurrency}
  />
)}
          {/* <Button
            variant="secondary"
            onClick={() =>
              navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`)
            }
          >
            Back
          </Button> */}
{!showBRBD&&<Button
  variant="primary"
  disabled={!selectedCustomer}
  onClick={() => setShowPostModal(true)}
>
  Post
</Button>}
<Modal show={showPostModal} onHide={() => setShowPostModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Post Document</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    Are you sure you want to post this document?
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPostModal(false)}>
      No
    </Button>

    <Button
      variant="primary"
      onClick={async () => {
        setShowPostModal(false);
        setCheckingInvoices(true);

        try {
          const res = await getOpenInvoices(
            selectedCustomer,
            user.organisationId
          );

          if (res && res.length > 0) {
            setOpenInvoices(res);
            setShowSettleModal(true);
          }
        } catch (err) {
          console.error("Error fetching open invoices", err);
        } finally {
          setCheckingInvoices(false);
        }
      }}
    >
      Yes
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={showSettleModal} onHide={() => setShowSettleModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Open Invoices Found</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    There are open invoices against this customer.  
    Do you want to settle them now?
  </Modal.Body>

  <Modal.Footer>
   <Button
  variant="secondary"
  onClick={async () => {
    try {
      setShowSettleModal(false);

      const payload = {
        statementId: statement.statementId,
        userId: user.userId,
        organisationId: user.organisationId,
        currency:selectedCurrency
      };

      await createSettlementNo(payload);

      alert("Statement settled successfully");

      navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`);
    } catch (err) {
      console.error("Settlement NO failed", err);
      alert("Something went wrong while settling");
    }
  }}
>
  No
</Button>


    <Button
      variant="primary"
      onClick={() => {
        setShowSettleModal(false);
        navigate(
  `/open-invoices/${selectedCustomer}`,
  {
    state: {
      invoices: openInvoices,
      statementAmount: statement.transactionAmount,
      statementId: statement.statementId,
    },
  }
);

      }}
    >
      Yes
    </Button>
  </Modal.Footer>
</Modal>

        </div>
      </div>
    </div>
  );
};

export default PostDocument;
